import type { DonorDonation } from '@/types/donorFinancialYear'
import type { FoundForYouDonation } from '@/types/foundForYou'

/** Queue item opened from the hunt wizard (not yet in the giving record). */
export function isFoundForYouDonation(donation: DonorDonation): boolean {
  return (
    donation.sourceCategory === 'found-for-you' || donation.source === 'found-for-you'
  )
}

/** Donation accepted through The Great Gift Aid Hunt and promoted to the giving record. */
export function isGiftAidHuntDonation(donation: DonorDonation): boolean {
  return donation.giftAidHuntAccepted === true
}

/** Map API queue row to a donation shape for display helpers. */
export function foundForYouToDonorDonation(item: FoundForYouDonation): DonorDonation {
  return {
    id: item.id,
    state: 'pending',
    charity: item.charity,
    amount: item.amount,
    giftaid: 0,
    potentialGiftAid: item.potentialGiftAid,
    time: item.donatedAt,
    source: item.matchMethod,
    sourceCategory: 'found-for-you',
    organisationType: item.organisationType,
    submittedAt: item.submittedAt,
    charityLogoUrl: item.charityLogoUrl,
    charityBrandColor: item.charityBrandColor,
  }
}
